import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';

import NotificationSettings from 'Settings/pages/UserSettingsPage/UserNotifications/NotificationSettings/NotificationSettings';

import WorkingHours from 'Settings/pages/UserSettingsPage/UserNotifications/WorkingHours/WorkingHours';

import styles from './UserNotifications.module.scss';

const UserNotifications = () => {
  const intl = useIntl();
  return (
    <div className={styles.content}>
      <div>
        <SectionHeading
          size="l"
          sticky
          title={intl.formatMessage({ id: 'WORKING_HOURS' })}
          style={{ margin: '0 0 2rem 0' }}
          testId="working-hours"
        />
        <WorkingHours />
      </div>
      <div>
        <SectionHeading
          size="l"
          sticky
          style={{ margin: '5rem 0 0 0' }}
          title={intl.formatMessage({ id: 'NOTIFICATION_SETTINGS' })}
          testId="notification-settings"
        />
        <NotificationSettings />
      </div>
    </div>
  );
};

export default UserNotifications;
